import React, { forwardRef } from 'react';

const IcStatusDisabled = forwardRef((properties, ref) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    fill: "none",
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    ...properties,
    ref
  },
  /* @__PURE__ */ React.createElement(
    "rect",
    {
      height: "10",
      rx: "5",
      stroke: "var(--color-status-device-disabled)",
      strokeWidth: "2",
      width: "10",
      x: "3",
      y: "3"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5 11.0002L11 5.00024",
      stroke: "var(--color-status-device-disabled)",
      strokeWidth: "2"
    }
  )
));

export { IcStatusDisabled };
//# sourceMappingURL=ic-status-disabled.js.map
